import React, { Component } from 'react';
import { pushBack, push } from './../../store/history.js';
import { fetchJson } from './../../core/ajax-json.js';
import { setRealityCheckDuration } from '../../reality-check/reality-check.js';

let timeLimitElement;
let selectedDuration;


class RealityCheckSetTimeLimit extends Component {
	componentWillMount() {
		timeLimitElement = document.getElementsByClassName('time-limit')[0];
		const backButtonElement = timeLimitElement.getElementsByClassName('js-close-button')[0];
		backButtonElement.onclick = () => {
			pushBack();
		};
		const selectBoxElement = timeLimitElement.getElementsByClassName('js-select-box')[0];
		const okButtonElement = timeLimitElement.getElementsByClassName('js-ok-button')[0];
		okButtonElement.onclick = () => {
			selectedDuration = selectBoxElement.children[selectBoxElement.selectedIndex].value;
			setRealityCheckDuration(selectedDuration);
			pushBack();
		};
		fetchJson('/player/limits/reality-check/duration')
			.then((response) => {
				if (response.result.timerDuration !== null) {
					for (let i = 0; i < selectBoxElement.children.length; i += 1) {
						const option = selectBoxElement.children[i];
						if (response.result.timerDuration === parseInt(option.value, 10)) {
							option.selected = true;
							break;
						}
					}
				}
				timeLimitElement.classList.add('menu--is-open');
			});
	}

	componentWillUnmount() {
		timeLimitElement.classList.remove('menu--is-open');
	}

	render() {
		return <div id="reality-check-set-limit" />;
	}
}

export default RealityCheckSetTimeLimit;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-reality-check-set-time-limit.js